export enum DashboardCacheKeys {
  CallOffsReport = 'calloffs-report',
  Arrivals = 'arrivals',
  Departures = 'departures',
  PendingOpenshiftApprovals = 'pending-openshift-approvals',
  OverVsUnder = 'over-vs-under',
  OverVsUnderTable = 'over-vs-under-table',
  HppdHours = 'hppd-hours',
  PendingRequestsCount = 'pending-requests-count',
  TaDashboard = 'ta-dashboard',
}
